import ReactJson from "react-json-view";
import { Card, useMantineTheme } from "@mantine/core";
import JsonViewer from "./jsonViewer";

const AIRequestPayload = ({ form, name }) => {
  const aiRequest = form.values;
  const theme = useMantineTheme();

  return (
    <Card withBorder mt="md" style={{ padding: "5px", margin: "0px" }}>
      <JsonViewer data={aiRequest.payload} name="payload" />
    </Card>
  );
};

export default AIRequestPayload;
